import { Outlet } from 'react-router-dom';
import config from '@/config';

function AuthLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-gray-900">{config.appName}</h1>
          <p className="text-sm text-gray-500 mt-1">Tournament Management System</p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}

export default AuthLayout;
